import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from "@angular/forms";
import {AbstractComponent} from "../abstract.component";
import {Country, Organiser, UserDetail, Lookups} from "@model";
import {alphabetical, email, max_length_255, max_length_50, required} from "@utility";
import {CodebookService} from '@services';

@Component({
    selector: 'app-new-organiser-modal',
    templateUrl: './new-organiser-modal.component.html',
    styleUrls: ['./new-organiser-modal.component.scss'],
    standalone: false
})
export class NewOrganiserModalComponent extends AbstractComponent implements OnInit {
  @Input() title: string | undefined;
  @Input() confirmButtonTitle: string | undefined;
  @Input() requestSent: boolean = true;
  @Input() dismissButtonTitle: string | undefined;

  countries: Country[] = [];
  currentUserDetails: UserDetail | undefined;

  inputForm = new FormGroup({
    name: new FormControl(),
    fullName: new FormControl(),
    website: new FormControl(),
    email: new FormControl(),
    phone: new FormControl(),
    address: new FormControl(),
    place: new FormControl(),
    country: new FormControl(),
    zip: new FormControl(),
  });

  constructor(public activeModal: NgbActiveModal,
              private codebookService: CodebookService) {
    super();
  }

  ngOnInit(): void {
    this.initCodebook();
    this.initForm();
  }

  private initCodebook() {
    //todo - check if getting from route data is possible
    this.subscriptions.push(this.codebookService.countries.value.subscribe((countries: Lookups[]) => {
      this.countries = countries;
    }))
  }

  private initForm() {
    this.inputForm.controls.name.addValidators([required, max_length_50]);
    this.inputForm.controls.fullName.addValidators([required, max_length_255]);
    this.inputForm.controls.website.addValidators([required, max_length_255]);
    this.inputForm.controls.email.addValidators([required, email]);
    this.inputForm.controls.phone.addValidators([required]);
    this.inputForm.controls.address.addValidators([required, max_length_255]);
    this.inputForm.controls.place.addValidators([required, max_length_255, alphabetical]);
    this.inputForm.controls.zip.addValidators([required, max_length_255]);
    this.inputForm.controls.country.addValidators([required]);
    this.inputForm.updateValueAndValidity();
  }

  private getOrganiserFields(): Organiser {
    this.checkValidators(this.inputForm);
    let organiserDetails: Organiser = new Organiser()
    organiserDetails.address = this.inputForm.value.address;
    organiserDetails.name = this.inputForm.value.name;
    organiserDetails.fullName = this.inputForm.value.fullName;
    organiserDetails.website = this.inputForm.value.website;
    organiserDetails.email = this.inputForm.value.email;
    organiserDetails.zip = this.inputForm.value.zip;
    organiserDetails.place = this.inputForm.value.place;
    organiserDetails.phone = this.inputForm.value.phone;
    let country = this.countries.find((country: Country) => country.id === this.inputForm.value.country);
    if (country) {
      organiserDetails.country = {
        countryId: country.id,
        shortCode: country.shortCode
      };
    } else {
      organiserDetails.country = undefined;
    }
    return organiserDetails;
  }

  onConfirmClick(): void {
    if (!this.inputForm.valid) {
      this.markAllAsTouched(this.inputForm);
    } else {
      this.activeModal.close(this.getOrganiserFields());
    }
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }
}

